import DropDown from "components/elements/atoms/DropDown/DropDown";
import FloatingInput from "components/elements/atoms/FloatingInput/FloatingInput";
import RectangularButton from "components/elements/molecules/RectangularButton/RectangularButton";
import { toast } from "components/elements/molecules/Toast/Toast";
import { useState } from "react";
import { Modal } from "react-bootstrap";

import './UpdateUserLevelModal.scss';

export default function UpdateUserLevelModal({
  actions,
  username,
  userLevel,
  refetch,
  onClose,
}) {
  const [level, setLevel] = useState({ label: userLevel, value: userLevel });
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = () => {
    setIsLoading(true);

    actions.updateUserLevel(username, userLevel, level.value)
      .then(() => {
        toast('User level updated!');
        refetch();
        onClose();
      })
      .catch(() => {
        setIsLoading(false);
        toast('Failed to update the user level', {
          type: 'error',
        },);
      });
  }

  const renderButton = () => {
    if (isLoading) {
      return (
        <span className="fa fa-spin fa-spinner" style={{ fontSize: '20px' }} />
      );
    }

    return (
      <RectangularButton
        onClick={() => {
          handleSave();
        }}
        disabled={!level || level < 1 || level > 6}
        darkButton
      >
        Save
      </RectangularButton>
    );
  }

  return (
    <Modal show className="update-user-level-modal" size="sm">
      <Modal.Header closeButton onHide={() => onClose()}>
        <Modal.Title>Update User Level</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <b>Current user level</b>: {userLevel}
        </div>
        <DropDown
          labelName="New level"
          value={level}
          onChange={(selectedOption) => setLevel(selectedOption)}
          options={[
            { label: 1, value: 1 },
            { label: 2, value: 2 },
            { label: 3, value: 3 },
            { label: 4, value: 4 },
            { label: 5, value: 5 },
            { label: 6, value: 6 },
          ]}
        />
      </Modal.Body>
      <Modal.Footer className="text-left">
        <div className="w-100">
          {renderButton()}
        </div>
      </Modal.Footer>
    </Modal>
  );
}